import { DefaultTheme } from 'styled-components';

export const darkTheme: DefaultTheme = {
  isLightTheme: false,
  bgColor: '#2f3640',
  textColor: '#f5f6fa',
  accentColor: '#9c88ff',
  boxColor: '#00000066',
};

export const lightTheme: DefaultTheme = {
  isLightTheme: true,
  bgColor: '#f5f5f5',
  textColor: '#222631',
  accentColor: '#7158e2',
  boxColor: '#ffffffee',
};
